import * as React from "react"
import { RouteComponentProps } from "@gatsbyjs/reach-router"
import { Signup as SignupScreen } from "@modules/user/signup/components/Signup"

export function Signup(props: RouteComponentProps) {
  return <SignupScreen {...props} />
}
